"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InputDescriptorsV2VB = void 0;
const ObjectValidationUtils_1 = require("../../utils/ObjectValidationUtils");
const constraintsVB_1 = require("./constraintsVB");
const validationBundler_1 = require("./validationBundler");
class InputDescriptorsV2VB extends validationBundler_1.ValidationBundler {
    constructor(parentTag) {
        super(parentTag, 'input_descriptor');
        this.idMustBeNonEmptyStringMsg = 'input descriptor id must be non-empty string';
        this.nameShouldBeNonEmptyStringMsg = 'input descriptor name should be non-empty string';
        this.purposeShouldBeNonEmptyStringMsg = 'input descriptor purpose should be non-empty string';
    }
    getValidations(inputDescriptors) {
        let validations = [];
        validations.push({
            tag: this.getTag(),
            target: inputDescriptors,
            predicate: (inDescs) => this.shouldNotHaveSchema(inDescs),
            message: 'input descriptor should not have schema property',
        }, {
            tag: this.getTag(),
            target: inputDescriptors,
            predicate: (inDescs) => this.shouldHaveUniqueIds(inDescs),
            message: 'input descriptor ids must be unique',
        }, {
            tag: this.getTag(),
            target: inputDescriptors,
            predicate: (inDescs) => this.shouldHaveUniqueFieldsIds(inDescs),
            message: 'fields id must be unique',
        });
        inputDescriptors.forEach((inputDescriptor, inDescInd) => {
            validations = [
                ...validations,
                ...this.getValidationFor(inputDescriptor, inDescInd),
                ...this.constraintsValidations(inputDescriptor, inDescInd),
            ];
        });
        return validations;
    }
    getValidationFor(inputDescriptor, inDescInd) {
        return [
            {
                tag: this.getMyTag(inDescInd),
                target: inputDescriptor,
                predicate: (inDesc) => ObjectValidationUtils_1.ObjectValidationUtils.nonEmptyString(inDesc === null || inDesc === void 0 ? void 0 : inDesc.id),
                message: this.idMustBeNonEmptyStringMsg,
            },
            {
                tag: this.getMyTag(inDescInd),
                target: inputDescriptor,
                predicate: (inDesc) => ObjectValidationUtils_1.ObjectValidationUtils.optionalNonEmptyString(inDesc === null || inDesc === void 0 ? void 0 : inDesc.name),
                message: this.nameShouldBeNonEmptyStringMsg,
            },
            {
                tag: this.getMyTag(inDescInd),
                target: inputDescriptor,
                predicate: (inDesc) => ObjectValidationUtils_1.ObjectValidationUtils.optionalNonEmptyString(inDesc === null || inDesc === void 0 ? void 0 : inDesc.purpose),
                message: this.purposeShouldBeNonEmptyStringMsg,
            },
        ];
    }
    shouldHaveUniqueFieldsIds(inputDescriptors) {
        const nonUniqueInputDescriptorFieldsIds = [];
        const uniqueInputDescriptorFieldsIds = new Set();
        const tmp = [];
        inputDescriptors
            .map((e) => { var _a; return (_a = e.constraints) === null || _a === void 0 ? void 0 : _a.fields; })
            .forEach((e) => {
            if (e) {
                tmp.push(...e);
            }
        });
        tmp.forEach((e) => {
            if (e.id) {
                nonUniqueInputDescriptorFieldsIds.push(e.id);
            }
        });
        nonUniqueInputDescriptorFieldsIds.forEach((id) => uniqueInputDescriptorFieldsIds.add(id));
        return nonUniqueInputDescriptorFieldsIds.length === uniqueInputDescriptorFieldsIds.size;
    }
    shouldHaveUniqueIds(inputDescriptors) {
        const nonUniqueInputDescriptorIds = [];
        const uniqueInputDescriptorIds = new Set();
        inputDescriptors.forEach((e) => nonUniqueInputDescriptorIds.push(e.id));
        nonUniqueInputDescriptorIds.forEach((e) => uniqueInputDescriptorIds.add(e));
        return nonUniqueInputDescriptorIds.length === uniqueInputDescriptorIds.size;
    }
    getMyTag(srInd) {
        // TODO extract to make it generic
        return this.parentTag + '.' + this.myTag + '[' + srInd + ']';
    }
    constraintsValidations(inputDescriptor, inDescInd) {
        if (inputDescriptor.constraints) {
            return new constraintsVB_1.ConstraintsVB(this.getMyTag(inDescInd)).getValidations(inputDescriptor.constraints);
        }
        return [];
    }
    shouldNotHaveSchema(inputDescriptors) {
        let hasSchema = false;
        inputDescriptors.forEach((id) => {
            if (id['schema']) {
                hasSchema = true;
            }
        });
        return !hasSchema;
    }
}
exports.InputDescriptorsV2VB = InputDescriptorsV2VB;
